import React from 'react';

import classNames from 'classnames';

export interface StatusSelectProps {
  value: string | null;
  onChange: (value: string | null) => void;
  options?: {
    value: string | undefined;
    label: string;
    className?: string;
    disabled?: boolean;
  }[];
  disabled?: boolean;
  withEmpty?: boolean;
  className?: string;
}

export const Select = ({
  value,
  onChange,
  options = [],
  disabled,
  withEmpty,
  className,
}: StatusSelectProps) => {
  const handleMouseDown = (e: React.MouseEvent<HTMLSelectElement>) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  if (withEmpty) {
    options = [{ value: undefined, label: 'All', className: 'bg-gray-200 text-black' }, ...options];
  }

  return (
    <div className="relative inline-block w-fit">
      <select
        value={value as string}
        onChange={(e) => onChange(e.target.value)}
        onMouseDown={handleMouseDown}
        disabled={disabled}
        className={classNames(
          'cursor-pointer py-1 px-2 pr-8 rounded-lg text-secondary-40 border-2 border-primary-20 rounded-lg text-md font-medium outline-none font-inter appearance-none',
          className,
        )}
      >
        {options.map((option) => (
          <option
            key={option.label}
            value={option.value}
            className={option.className}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      {!disabled && (
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          <svg
            className="w-4 h-4 text-neutral-70"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      )}
    </div>
  );
};
